<template>
  <div>
    <base-header class="mt-4 pb-6" type=""/>
    <b-container fluid class="mt--6 container-padding">
        <div>
          <loading :active.sync="loading" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" :is-full-page="true"></loading>
        </div>
        <b-row>
          <b-col cols="12">
            <div class="card-wrapper">
               <b-card>
                  <div slot="header" class="mb-0">
                    <b-row>
                      <b-col cols="8">
                          <h3>{{language_terms['CHART_OF_ACCOUNT']}}</h3>
                      </b-col>
                      <b-col cols="4">
                        <base-button type="success" @click="newAction" class="float-right">
                            <i class="fa fa-plus"></i>
                            {{title}}
                          </base-button>
                      </b-col>
                    </b-row>
                  </div>
                  <b-row>
                      <b-col cols="3">
                        <base-input :label="language_terms['FINANCIAL_YEAR']" >
                          <el-select v-model="selected_fy" filterable :placeholder="language_terms['FINANCIAL_YEAR']" @change="onChangeFinancialYear">
                              <el-option v-for="option in fys"
                                      :key="option.fy"
                                      :label="option.fy"
                                      :value="option.fy">
                              </el-option>
                          </el-select>
                        </base-input>
                      </b-col>
                      <b-col cols="3" class="mt-4">
                        <base-button type="success" @click="newFY" class="mt-2">
                            <i class="fa fa-plus"></i>
                            {{language_terms['FINANCIAL_YEAR']}}
                          </base-button>
                      </b-col>
                    <b-col cols="12" v-if="selected_fy && 0 ">
                        <div>
                           <span>{{language_terms['FROM']}} </span> 
                           <span class="font-weight-bold">
                             {{getSelectedFYDetails(selected_fy).date_from ? getSelectedFYDetails(selected_fy).date_from : '-'}}
                           </span>
                           <span>{{language_terms['To']}} </span> 
                           <span class="font-weight-bold"> {{getSelectedFYDetails(selected_fy).date_to ? getSelectedFYDetails(selected_fy).date_to : '-'}}</span>
                        </div>
                    </b-col>
                    <b-col cols="12">
                      <b-tabs content-class="mt-3" card>
                            <div v-for="(value, name) in items" :key="name">
                              <b-tab :title="language_terms[name]">
                                <div>
                                  <b-table-simple v-if="value.length > 0" hover responsive>
                                    <b-thead head-variant="light">
                                      <b-th>{{language_terms['CODE']}}</b-th>
                                      <b-th>{{language_terms['NAME']}}</b-th>
                                      <b-th>{{language_terms['CURRENT']}} (SGD)</b-th>
                                      <b-th>{{language_terms['OPENING']}} (SGD)</b-th>
                                      <b-th>{{language_terms['YTD']}} (SGD)</b-th>
                                    </b-thead>
                                    <b-tbody>
                                      <tr v-for="(row, i) in value" :key="i">
                                        <td v-on:click="handleEdit(row)">{{row.code}}</td>
                                        <td v-on:click="handleEdit(row)">{{row.name}}</td>
                                        <td v-on:click="handleEdit(row)">{{(row.current_balance * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                                        <td v-on:click="handleEdit(row)">{{(row.opening_balance * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                                        <td v-on:click="handleEdit(row)">{{(row.ytd_balance * 1).toLocaleString('en-SG', {style: 'currency', minimumFractionDigits:2, maximumFractionDigits:2, currency: 'SGD', currencySign: 'accounting'})}}</td>
                                      </tr>
                                    </b-tbody>
                                  </b-table-simple>                                  
                                  <!-- <b-table :items="value" :fields="tableColumns" head-variant="light"  v-if="value.length > 0" @row-clicked="handleEdit(row)">
                                      <template #cell(index)="data">
                                          {{data.index + 1}}
                                      </template>
                                      <template #cell(balance)="row">
                                        {{row.item.balance >= 0 ? row.item.balance : "(" + row.item.balance + ")"}}
                                      </template>
                                  </b-table> -->
                                </div>
                              </b-tab>
                            </div>
                        </b-tabs>
                    </b-col>
                  </b-row>
               </b-card>
            </div>
          </b-col>
        </b-row>

    </b-container>
    <b-modal v-model="create_fy_modal" centered no-close-on-backdrop class="my-modal" size="lg" :title="language_terms['NEW_FINANCIAL_YEAR']">
      <b-card>
        <b-row>
          <b-col cols="12">
            <base-input :label="language_terms['FINANCIAL_YEAR']" v-model="new_fy" type="number" placeholder="Eg: 2021"></base-input>
          </b-col>
          <b-col cols="6">
            <base-input :label="language_terms['DATE_FROM']">
                <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    style="background-color: white"
                    class="form-control datepicker"
                    v-model="date_from">
                </flat-picker>
            </base-input>
          </b-col>
          <b-col cols="6">
            <base-input :label="language_terms['DATE_TO']">
                <flat-picker
                    slot-scope="{ focus, blur }"
                    @on-open="focus"
                    @on-close="blur"
                    style="background-color: white"
                    class="form-control datepicker"
                    v-model="date_to">
                </flat-picker>
            </base-input>
          </b-col>
        </b-row>
      </b-card>
      <template #modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button variant="primary" @click="confirmCreateFY()">
          {{language_terms['CONFIRM']}}
        </b-button>
        <b-button variant="danger" @click="cancelModal()">
          {{language_terms['CANCEL']}}
        </b-button>
    </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../../Components/masterList.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Select, Option } from "element-ui";
import PaginatedTables from "@/views/Tables/PaginatedTables";
import { Table, TableColumn } from 'element-ui';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'

export default {
  components: {
    PaginatedTables,
    masterList,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker
  },
  data() {
    return {
      new_fy:null,
      date_from:"",
      date_to:"",
      headerBgVariant: "primary",
      headerTextVariant: "light",
      create_fy_modal:false,
      loading:false,
      title:"",
      items:[],
      filter:{
        keyword:"",
        active_only:"1",
        account_id:null
      },
      selected_fy:null,
      activeOptions: 
      [
        {
          value: "1",
          label: "Yes",
        },
        {
          value: "0",
          label: "No",
        },
      ],
      tableColumns: 
      [
        {
          key: "code",
          label: "ACCOUNT_CODE",
          minWidth: 100,
          sortable: true,
        },
        {
          key: "name",
          label: "ACCOUNT_NAME",
          minWidth: 180,
          sortable: true,
          // key:"ACCOUNT_NAME"
        },
        // {
        //   key: "currency_code",
        //   label: "CURRENCY",
        //   minWidth: 100,
        //   sortable: true,
        // },
        {
          key: "opening_balance",
          label: "OPENING",
          minWidth: 100,
          sortable: true,
        },
        {
          key: "current_balance",
          label: "BALANCE",
          minWidth: 100,
          sortable: true,
          // key:"BALANCE"
        },
        {
          key: "ytd_balance",
          label: "BALANCE",
          minWidth: 100,
          sortable: true,
          // key:"BALANCE"
        },
      ]
    };
  },
  computed:{
    ...mapState({
          language_terms:(state)=>state.languages.language_terms,
          account_filter: (state) => state.accounts.filter,
          accounts: (state) => state.accounts.accounts,
          fys: (state) => state.accounts.fys,
          is_fy_created:(state) => state.accounts.is_fy_created
    })
  },

  watch:{
    language_terms:{
      handler(val){
        //this.updateTableLang()
      },
    }
  },
  methods:{
      moment: function () {
        return moment();
      },
      async confirmCreateFY()
      {
        await this.$store.dispatch("accounts/createNewFY", {fy:this.new_fy, date_from:this.date_from, date_to:this.date_to })
        if(this.is_fy_created)
        {
            await this.$store.dispatch("accounts/fetchFYs", {})
            this.new_fy = null
            this.date_from = null
            this.date_to = null
            this.create_fy_modal = false
        }
      },
      cancelModal()
      {
          this.create_fy_modal = false
      },
      newFY()
      {
        this.create_fy_modal = true
      },
      handleEdit(row) 
      {
        if(row)
        {
          if(this.selected_fy == null)
          {
            this.selected_fy = "default"
          }

          this.$router.push({ path: '/finance/chart-of-accounts/' + row.id, query: { fy: this.selected_fy} })
        }

      },
      getSelectedFYDetails(fy)
      {
          let selected = null;

          let filter_obj = this.fys.filter(function (el) {
            return el.fy == fy
          });

          if(filter_obj)
          {
            selected = filter_obj[0]
          }

          return selected
      },
      async onChangeFinancialYear()
      {
        console.log(this.selected_fy)
        let selected = this.getSelectedFYDetails(this.selected_fy)

        if(selected)
        {
          //console.log(selected)
          this.filter.account_id = selected.id
          await this.clickOnSearch()
        }


      },
      async clickOnSearch()
      {
        this.loading = true;
        await this.$store.dispatch("accounts/quickSearch", this.filter)
        this.items = this.accounts

        this.loading = false;
      },
      newAction()
      {
        this.$router.push({ path: '/finance/chart-of-accounts/_new', query: { fy: this.selected_fy} })
      },
      updateTableLang()
      {
        for(let i = 0; i < this.tableColumns.length; i++)
        {
          let key = this.tableColumns[i].key
          this.tableColumns[i].label = this.language_terms[key]
        }
      }
  },
  async mounted()
  {
    this.updateTableLang()

    await this.$store.dispatch("accounts/fetchFYs", {})

    if(this.fys.length > 0)
    {
      this.filter.account_id = this.fys[0].id
      await this.clickOnSearch()
      this.selected_fy = moment().format('YYYY')
      this.onChangeFinancialYear()
    }


    this.title = this.language_terms['ACCOUNT']
  }
};
</script>


<style>
</style>